import { createTheme } from "@mui/material/styles";
import variableConstants from "./styleVariables";

const theme = createTheme({
  // palette: {
  //   primary: {
  //     main: variableConstants.colors.brand[1],
  //   },
  //   secondary: {
  //     main: variableConstants.colors.brand[2],
  //   },
  // },

  typography: {
    fontFamily: "Roboto, sans-serif",
    htmlFontSize: 16,
    fontSize: 16,
    h1: {
      letterSpacing: "1px",
      fontSize: "2rem",
      lineHeight: 1.4,
      "@media (min-width:600px)": {
        fontSize: "2.5rem",
      },
      "@media (min-width:960px)": {
        fontSize: "3rem",
      },
      "@media (min-width:1280px)": {
        fontSize: "4rem",
      },
      "@media (min-width:1920px)": {
        fontSize: "5rem",
      },
    },
    h2: {
      letterSpacing: "1px",
      fontSize: "1.5rem",
      lineHeight: 1.4,
      "@media (min-width:600px)": {
        fontSize: "1.75rem",
      },
      "@media (min-width:960px)": {
        fontSize: "2rem",
      },
      "@media (min-width:1280px)": {
        fontSize: "2.3rem",
      },
      "@media (min-width:1920px)": {
        fontSize: "3rem",
      },
    },
    h3: {
      letterSpacing: "1px",
      fontSize: "2.25rem",
      lineHeight: 1.4,
    },
    h4: {
      letterSpacing: "1px",
      fontSize: variableConstants.fontSize.medium,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: variableConstants.fontSize.xxlarge,
      lineHeight: 1.4,
    },
    body1: {
      letterSpacing: "0.5px",
      fontSize: variableConstants.fontSize.medium,
      lineHeight: 1.4,
      // "@media (min-width:600px)": {
      //   fontSize: "1rem",
      // },
      // "@media (min-width:960px)": {
      //   fontSize: "1rem",
      // },
      // "@media (min-width:1280px)": {
      //   fontSize: "1rem",
      // },
      // "@media (min-width:1920px)": {
      //   fontSize: "1.25rem",
      // },
    },
    body2: {
      letterSpacing: "0.5px",
      fontSize: variableConstants.fontSize.small,
      lineHeight: 1.4,
    },
    subtitle1: {
      letterSpacing: "1px",
      fontSize: variableConstants.fontSize.xsmall,
      lineHeight: 1.4,
    },
  },
});

export default theme;
